import React from 'react';

type Props = {
  link: string;
  children: any;
  disableLinkOnNewTab: boolean;
  handleCustomClick?: (...x: any[]) => void;
};

const CommonLinkWrapper = (
  props: Partial<Props & React.HTMLProps<HTMLAnchorElement>>
) => {
  const { link = '', disableLinkOnNewTab = false, handleCustomClick } = props;
  return (
    <a
      href={!(disableLinkOnNewTab || handleCustomClick) ? link : undefined}
      {...props}
      onClick={(e) => {
        props.onClick?.(e);
        handleCustomClick?.();
      }}
      className={'tw-text-inherit tw-no-underline ' + (props.className || '')}
    >
      {props.children}
    </a>
  );
};

export default CommonLinkWrapper;
